import { render, staticRenderFns } from "./rightCircleList.vue?vue&type=template&id=520b86d5&scoped=true"
import script from "./rightCircleList.vue?vue&type=script&lang=js"
export * from "./rightCircleList.vue?vue&type=script&lang=js"
import style0 from "./rightCircleList.vue?vue&type=style&index=0&id=520b86d5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520b86d5",
  null
  
)

export default component.exports